import React from 'react';

import { Button as AntdButton } from 'antd';

import { useFormActionsContext } from 'components/WrappedComponents';
import { unsafeCast } from 'typeGuards/typeGuards';
import { FilterDashboardFourriere } from 'types/referentiels/Fourriere';

import './FormFooter.less';

interface FormActionProps {
  setFilter: (value: FilterDashboardFourriere) => void;
}

export function FormFooter({ setFilter }: FormActionProps): React.ReactElement {
  const formActions = useFormActionsContext();

  function resetFilter() {
    formActions.setFieldsValue({
      idCorrelation: undefined,
      codePostal: undefined,
      commune: undefined,
      emptyIdAlienation: undefined,
      idCorrelationAF: undefined,
      idAlienation: undefined,
      raisonSociale: undefined,
      enabled: undefined,
    });
  }

  return (
    <div className={'form-footer-container'}>
      <AntdButton onClick={resetFilter}>Réinitialiser</AntdButton>

      <AntdButton
        type={'primary'}
        onClick={() => setFilter(unsafeCast(formActions.getFieldsValue()))}
      >
        Rechercher
      </AntdButton>
    </div>
  );
}

export default FormFooter;
